module.exports = __webpack_public_path__ + "img/consult_code.58ed4ae4.jpg";